export const SearchFilterStyles = {
  findButton: {
    "&:disabled": {
      color: "#FFFFFF",
      backgroundColor: "rgba(0, 0, 0, 0.12)"
    }
  }
};
